"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _default = new _immutable.Record({
  adId: null,
  enabled: null,
  pixelId: null,
  type: null
}, 'AdRoll');

exports.default = _default;
module.exports = exports.default;